import React from 'react';
import { Link } from 'wouter';

interface HeaderProps {
  title?: string;
  subtitle?: string;
}

const Header: React.FC<HeaderProps> = ({ 
  title = "FitTrack", 
  subtitle = "Your personal workout companion" 
}) => {
  return (
    <header className="bg-primary text-white p-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="font-heading text-xl font-bold">{title}</h1>
          <p className="text-sm opacity-90">{subtitle}</p>
        </div>
        {/* Account and notification icons removed */}
      </div>
    </header>
  );
};

export default Header;
